import React, {useEffect, useState} from 'react'
import styles from './skillActivity.module.scss'
import Fuse from 'Class/Fuse'
import IconItem from 'Components/UI/IconItem'
import Link from 'Components/UI/Link'
import LoadImage from 'Components/Layout/LoadImage'
import Spinner from 'Components/Feedback/Spinner'
import {StripTags, TimeSince} from 'Functions'

function SkillActivitySubscriber({
    className = '',
    getTranslation = () => {},
    id,
    status = '',
    updated,
    user
}) {
    const [error, setError] = useState(false)
    const [image, setImage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [mounted, setMounted] = useState(false)
    const [name, setName] = useState('')
    const classNames = [
        styles.subscriber,
        className
    ].filter(c => !!c).join(' ')

    const load = (id) =>
    {
        if (!mounted)
        {
            return;
        }
        setLoading(true)
        Fuse.Content(id, 'user', user =>
        {
            if (!mounted)
            {
                return;
            }
            setLoading(false)

            if (!user?.type)
            {
                setError(true)
            }
            else
            {
                setError(false)
                setImage(user?.preview || null)
                setName(StripTags(user?.name || ''))
            }
        })
    }

    useEffect(() =>
    {
        setMounted(true)
        return () => setMounted(false)
    })

    useEffect(() => 
    {
        load(user)
    }, [user, mounted])

    if (error) {
        return (
            <div className={classNames + ' ' + styles.error}>
                <div className={styles.subscriberPreview + ' ItemBackground'}></div>
                <div className={styles.subscriberContent}>
                    <h4>{ getTranslation('usererror') }</h4>
                    <IconItem
                        className={styles.subscriberRetry}
                        feather="RefreshCw"
                        label={ getTranslation('retry') }
                        loading={loading}
                        onClick={() => load(id)}
                    />
                </div>
            </div>
        )
    }
    else if (loading)
    {
        return (
            <div className={classNames}>
                <div className={styles.subscriberPreview + ' ItemBackground'}></div>
                <div className={styles.subscriberContent}>
                    <h4>{ getTranslation('loading') }</h4>
                    <Spinner size={22} />
                </div>
            </div>
        )
    }
    else
    {
        return (
            <Link className={classNames} href={Fuse.ContentUrl(user, 'user')}>
                <div className={styles.subscriberPreview + ' ItemBackground'}>
                    {image && <LoadImage
                        className={styles.subscriberPreviewImage}
                        src={image}
                    />}
                </div>
                <div className={styles.subscriberContent}>
                    <h4>{ name }</h4>
                    <div className={styles.subscriberStatus}>
                        <div className={[styles.subscriberStatusBadge, styles[`status_${status}`]].join(' ')}>{ getTranslation(`status_${status}`) }</div>
                        <div className={styles.subscriberStatusUpdated}>{ TimeSince(updated, true) }</div>
                    </div>
                </div>
            </Link>
        )
    }
}

export default SkillActivitySubscriber